import React from 'react';
import {
  Grid,
  TextField,
  Typography,
  Box,
  InputAdornment,
  MenuItem,
  Link
} from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import WorkIcon from '@mui/icons-material/Work';
import ChatIcon from '@mui/icons-material/Chat';

const UserDetailsForm = ({ userData, errors, onChange }) => {
  const roleOptions = [
    'Executive',
    'Manager',
    'Individual Contributer',
    'Other'
  ];

  const waPlanOptions = [
    'WhatsApp Lite',
    'WhatsApp Advance',
    'WhatsApp Advance Custom Solution',
    'Enterprise WhatsApp Solution'
  ];

  return (
    <Box sx={{ mt: 2 }}>
      <Typography variant="h6" gutterBottom>
        Profile Setup
      </Typography>
      <Typography variant="body2" color="textSecondary" paragraph>
        Please provide your personal information to create your account.
      </Typography>
      
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6}>
          <TextField
            required
            fullWidth
            id="firstName"
            label="First Name"
            name="firstName"
            value={userData.firstName}
            onChange={(e) => onChange('firstName', e.target.value)}
            error={!!errors.firstName}
            helperText={errors.firstName}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <PersonIcon color="action" />
                </InputAdornment>
              ),
            }}
          />
        </Grid>
        
        <Grid item xs={12} sm={6}>
          <TextField
            required
            fullWidth
            id="lastName"
            label="Last Name"
            name="lastName"
            value={userData.lastName}
            onChange={(e) => onChange('lastName', e.target.value)}
            error={!!errors.lastName}
            helperText={errors.lastName}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <PersonIcon color="action" />
                </InputAdornment>
              ),
            }}
          />
        </Grid>
        
        <Grid item xs={12} sm={6}>
          <TextField
            required
            fullWidth
            id="email"
            label="Work Email"
            name="email"
            type="email"
            value={userData.email}
            onChange={(e) => onChange('email', e.target.value)}
            error={!!errors.email}
            helperText={
              errors.emailAction === 'login' ? (
                <span>
                  Looks like you are already a BotBridge user. Please <Link href="/login" target="_blank" rel="noopener">login</Link>
                </span>
              ) : errors.email
            }
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <EmailIcon color="action" />
                </InputAdornment>
              ),
            }}
          />
        </Grid>
        
        <Grid item xs={12} sm={6}>
          <TextField
            required
            fullWidth
            id="phone"
            label="Contact Phone Number"
            name="phone"
            value={userData.phone}
            onChange={(e) => onChange('phone', e.target.value)}
            error={!!errors.phone}
            helperText={errors.phone}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <PhoneIcon color="action" />
                </InputAdornment>
              ),
            }}
          />
        </Grid>
        
        <Grid item xs={12} sm={12}>
          <TextField
            required
            fullWidth
            select
            id="role"
            label="Your Role"
            name="role"
            value={userData.role}
            onChange={(e) => onChange('role', e.target.value)}
            error={!!errors.role}
            helperText={errors.role}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <WorkIcon color="action" />
                </InputAdornment>
              ),
            }}
          >
            {roleOptions.map((option) => (
              <MenuItem key={option} value={option}>
                {option}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        
        <Grid item xs={12} sm={12}>
          <TextField
            required
            fullWidth
            select
            id="waPlan"
            label="Select WhatsApp Plan"
            name="waPlan"
            value={userData.waPlan}
            onChange={(e) => onChange('waPlan', e.target.value)}
            error={!!errors.waPlan}
            helperText={errors.waPlan}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <ChatIcon color="action" />
                </InputAdornment>
              ),
            }}
          >
            {waPlanOptions.map((option) => (
              <MenuItem key={option} value={option}>
                {option}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
      </Grid>
    </Box>
  );
};

export default UserDetailsForm;